






























































import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: {
  }
})

export default class myPageModal extends Vue {
    @Prop() private mail! : string;

    @Prop({
        default: () => ({
            needsRecommend: ""
        })
    }) form!: { needsRecommend: string };
    title = "ラベル屋さんアカウント";

    password = "**********";

    private onDoCommand(command: string, param: any){
        this.$emit("doCommand", command, param);
    }

    private changeMail(){
        this.onDoCommand("changeMail", null);
    }

    private changePassword(){
        this.onDoCommand("changePassword", null);
    }

    changeNeedsRecommend() {
        this.onDoCommand("changeNeedsRecommend", this.form.needsRecommend);
    }

    private close(){
        this.$emit('close');
    }

    private get userConfigColor(){
        return this.$store.getters.userConfigColors.buttonColorCode;
    }
    private get userConfigBackgroundColor(){
        var style = {
            background: this.userConfigColor
        };
        return style;
    }
    private get userConfigUnderLineColor(){
        var style = {
            borderBottom: "solid 1px " + this.userConfigColor
        };
        return style;
    }
}
